/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const scenarioItemFiltersSchema = z.object({
  estimationIds: z.array(z.int()).nullish(),
  inDoneSubtree: z.boolean(),
  isMLImputed: z.boolean(),
  itemStatusIds: z.array(z.int()).nullish(),
  itemTypeIds: z.array(z.int()).nullish(),
  needsTeamOrEstimate: z.boolean(),
  noEstimateSet: z.boolean(),
  noTeamSet: z.boolean(),
  searchText: z.string().min(0).max(50).nullish(),
  teamIds: z.array(z.int()).nullish(),
  unparented: z.boolean(),
});
